import { render, staticRenderFns } from "./global-message-user.html?vue&type=template&id=45d0e608&external"
import script from "./global-message-user.js?vue&type=script&lang=js&external"
export * from "./global-message-user.js?vue&type=script&lang=js&external"
import style0 from "./global-message-user.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports